<template>
  <div class="new-input-wrapper base-date-field">
    <label v-if="label" class="base-date-field__label">{{ label }}</label>
    <div class="base-date-field__control new-input">
      <span class="base-date-field__icon sienit">D</span>
      <input
        class="base-date-field__input date"
        type="text"
        :placeholder="placeholder"
        :value="formattedDate"
        :disabled="disabled"
        readonly
        @click="openDropdown"
        @focus="openDropdown"
        @blur="closeDropdown"
      />
      <span v-if="disabled" class="base-date-field__disabled disabled">A</span>
    </div>
    <div
      class="base-date-field__dropdown new-input-dropdown datepicker-dropdown"
      :class="{ 'datepicker-dropdown-active': isDropdownOpen }"
    >
      <datepicker
        :language="bg"
        :inline="true"
        :monday-first="true"
        :wrapper-class="'custom-datepicker'"
        :calendar-class="'custom-calendar'"
        :value="dateValue"
        @selected="selectDate"
      ></datepicker>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";

export default {
  name: "BaseDateField",
  components: {
    Datepicker,
  },
  props: {
    value: {
      type: [Date, String],
      default: null,
    },
    label: {
      type: String,
      default: "Дата",
    },
    placeholder: {
      type: String,
      default: "Дата",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bg,
      isDropdownOpen: false,
    };
  },
  computed: {
    dateValue() {
      return this.value ? new Date(this.value) : new Date();
    },
    formattedDate() {
      const date = this.dateValue;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}/${month}/${date.getFullYear()}`;
    },
  },
  methods: {
    openDropdown() {
      if (!this.disabled) this.isDropdownOpen = true;
    },
    closeDropdown() {
      setTimeout(() => {
        this.isDropdownOpen = false;
      }, 100);
    },
    selectDate(date) {
      this.$emit("input", date);
      this.$emit("selected", date);
      this.closeDropdown();
    },
  },
};
</script>

<style scoped lang="scss">
.base-date-field {
  margin-right: 0;
  width: 100%;

  &__control {
    margin: 4px 0 0;
  }

  &__input {
    background: #f8fbff;
    border-color: #c8d7e6;
    min-height: 34px;
    padding-left: 36px;
  }

  &__dropdown {
    border-color: #c8d7e6;
    box-shadow: 0 10px 28px rgba(49, 68, 91, 0.15);
    left: auto;
    overflow: visible;
    padding: 8px;
    right: -25%;
    width: 220px;
    z-index: 6;
  }

  ::v-deep .custom-datepicker {
    padding: 0 !important;
  }

  ::v-deep .vdp-datepicker__calendar {
    color: #142033;
    font-size: 13px;
    line-height: 1;

    header {
      height: 34px;
      line-height: 34px;

      span {
        font-weight: 700;
      }
    }

    .cell {
      align-items: center;
      border: 1px solid transparent;
      display: inline-flex;
      height: 30px;
      justify-content: center;
      line-height: 30px;
      margin: 1px 0;

      &.day-header {
        color: #34475e;
        font-size: 12px;
        font-weight: 700;
        height: 28px;
      }
    }
  }
}
</style>
